import { render, staticRenderFns } from "./DonutChart11.vue?vue&type=template&id=723ff4d9&scoped=true"
import script from "./DonutChart11.vue?vue&type=script&lang=js"
export * from "./DonutChart11.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723ff4d9",
  null
  
)

export default component.exports